import images from "./images";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to Eternal Vows",
    title: "Exceptional Wedding Planning Tailored to You",
    buttonText: "Plan Your Wedding",
    buttonLink: "Booking",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Welcome to Eternal Vows",
    title: "Stunning Venues and Perfect Details",
    buttonText: "Plan Your Wedding",
    buttonLink: "Booking",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Welcome to Eternal Vows",
    title: "Unforgettable Moments and Magical Experiences",
    buttonText: "Plan Your Wedding",
    buttonLink: "Booking",
  },
];

export default home;